module.exports = __webpack_public_path__ + "img/49.94a6be62.png";